
























































































































import Vue from 'vue';
import { toString, get, set, isNil } from 'lodash';
import moment from 'moment';
import { CloseFullscreenWrapper, TriggerRefreshError } from '@/mixins';
import {
  BeneficiariesReview,
  BeneficiaryForm,
} from '@/components/account-components';
import {
  FullscreenWrapper,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import { dialogMaxWidth, datePickerFormat, PRIMARY_BENEFICIARY, CONTINGENT_BENEFICIARY } from '@/constants';
import { ExtendMixins } from '@/services';
import { AccountBeneficiaryResponseModel } from '@/@types/member';

interface Data {
  changeMade: boolean;
  accountId: string;
  previousScreen: string;
  isSubmitLoading: boolean;
  showSubmitSuccessMessage: boolean;
  successMessage: string;
  showSubmitErrorMessage: boolean;
  errorMessage: string;
  errorStatusCode: string;
  confirmBeforeClose: boolean;
  beneficiaries: AccountBeneficiaryResponseModel[];
  workingBeneficiaries: AccountBeneficiaryResponseModel[];
  pendingBeneficiaries: AccountBeneficiaryResponseModel[];
  currentBeneficiary: AccountBeneficiaryResponseModel;
  showReviewScreen: boolean;
  showConfirmModal: boolean;
  showRemoveModal: boolean;
  dialogMaxWidth: string;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
).extend({
  name: 'UpdateBeneficiariesWrapper',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data() {
    return {
      changeMade: false,
      accountId: this.$route.params.id,
      previousScreen: this.params.previousScreen,
      isSubmitLoading: false,
      showSubmitSuccessMessage: false,
      successMessage: this.params.successMessage,
      showSubmitErrorMessage: false,
      errorMessage: this.params.errorMessage,
      errorStatusCode: null,
      confirmBeforeClose: true,
      beneficiaries: [],
      workingBeneficiaries: [],
      pendingBeneficiaries: [],
      currentBeneficiary: null,
      showReviewScreen: this.params.showReview || false,
      showConfirmModal: false,
      showRemoveModal: false,
      dialogMaxWidth,
    };
  },
  computed: {
    primaryBeneficiaries(): AccountBeneficiaryResponseModel[] {
      if (this.beneficiaries) {
        return this.beneficiaries.filter((beneficiary) => {
          return beneficiary.type === PRIMARY_BENEFICIARY;
        });
      }
      return [];
    },
    secondaryBeneficiaries(): AccountBeneficiaryResponseModel[] {
      if (this.workingBeneficiaries) {
        return this.workingBeneficiaries.filter((beneficiary) => {
          return beneficiary.type === CONTINGENT_BENEFICIARY;
        });
      }
      return [];
    },
    primarySharePercentage(): string {
      return this.workingBeneficiaries.reduce(
        (totalPercentage, beneficiary) => {
          if (beneficiary.type === PRIMARY_BENEFICIARY) {
            totalPercentage += parseInt(beneficiary.sharePercentage);
          }
          return totalPercentage;
        },
        0,
      );
    },
    hasPrimaryBeneficiaries(): boolean {
      return !!this.primarySharePercentage;
    },
    confirmRemoveBeneficiaryTitle(): string {
      if (
        this.currentBeneficiary &&
        this.currentBeneficiary.type === PRIMARY_BENEFICIARY &&
        !this.primarySharePercentage &&
        this.secondaryBeneficiaries.length
      ) {
        return this.$options.filters.t([
          'beneficiaries_title_confirm-remove-all-beneficiaries',
          'beneficiaries_title_confirm-remove-beneficiary',
        ]);
      }
      return this.$options.filters.t(
        'beneficiaries_title_confirm-remove-beneficiary',
      );
    },
    confirmRemoveBeneficiaryText(): string {
      if (
        this.currentBeneficiary &&
        this.currentBeneficiary.type === PRIMARY_BENEFICIARY &&
        this.secondaryBeneficiaries.length
      ) {
        const remainingPrimarySharePercentage =
          parseInt(this.primarySharePercentage) - this.currentBeneficiary.sharePercentage;
        if (!remainingPrimarySharePercentage) {
          return this.$options.filters.t(
            'beneficiaries_text_confirm-remove-all-beneficiaries',
          );
        }
      }
      return this.$options.filters.t(
        'beneficiaries_text_confirm-remove-beneficiary',
      );
    },
  },
  beforeMount() {
    this.beneficiaries = this.$store.getters.currentBeneficiaries;
    this.workingBeneficiaries = this.beneficiaries.map((obj) => {
      return JSON.parse(JSON.stringify(obj));
    });
  },
  methods: {
    tryAgain(): void {
      this.showSubmitErrorMessage = false;
      this.confirmBeforeClose = true;
    },
    addBeneficiaryModel(model): void {
      this.pendingBeneficiaries.push(Object.assign(model, { action: 'add' }));
      this.workingBeneficiaries.push(model);
      this.changeMade = true;
      this.showReviewScreen = true;
    },
    updateBeneficiaryModel(model): void {
      this.currentBeneficiary = Object.assign(this.currentBeneficiary, model);
      if (model.action) {
        if (model.action !== 'add') {
          this.currentBeneficiary = Object.assign(this.currentBeneficiary, {
            action: 'update',
          });
        }
      } else {
        this.pendingBeneficiaries.push(
          Object.assign(this.currentBeneficiary, { action: 'update' }),
        );
      }
      this.currentBeneficiary = null;
      this.changeMade = true;
      this.showReviewScreen = true;
    },
    removeBeneficiaryModel(): void {
      if (this.pendingBeneficiaries.indexOf(this.currentBeneficiary) > -1) {
        if (this.currentBeneficiary.action === 'add') {
          this.pendingBeneficiaries.splice(
            this.pendingBeneficiaries.indexOf(this.currentBeneficiary),
            1,
          );
        }
      } else {
        this.pendingBeneficiaries.push(this.currentBeneficiary);
      }

      this.currentBeneficiary = Object.assign(this.currentBeneficiary, {
        sharePercentage: '0',
        action: 'update',
      });

      if (
        this.currentBeneficiary.type === PRIMARY_BENEFICIARY &&
        !this.primarySharePercentage &&
        this.secondaryBeneficiaries.length
      ) {
        this.removeAllSecondaryBeneficiaries();
      } else {
        this.changeMade = true;
        this.showRemoveModal = false;
      }
    },
    removeAllSecondaryBeneficiaries(): void {
      this.secondaryBeneficiaries.forEach((beneficiary) => {
        // @ts-ignore
        if (this.pendingBeneficiaries.indexOf(this.beneficiary) > -1) {
          // @ts-ignore
          if (this.beneficiary.action === 'add') {
            this.pendingBeneficiaries.splice(
              this.pendingBeneficiaries.indexOf(beneficiary),
              1,
            );
          }
        } else {
          this.pendingBeneficiaries.push(beneficiary);
        }
        beneficiary = Object.assign(beneficiary, {
          sharePercentage: '0',
          action: 'update',
        });
      });
      this.changeMade = true;
      this.showRemoveModal = false;
    },
    showAddBeneficiaryScreen(): void {
      this.currentBeneficiary = null;
      this.previousScreen = 'review';
      this.showReviewScreen = false;
    },
    showEditBeneficiaryScreen(model): void {
      this.currentBeneficiary = model;
      this.previousScreen = 'review';
      this.showReviewScreen = false;
    },
    showRemoveBeneficiaryModal(model): void {
      this.currentBeneficiary = model;
      this.previousScreen = 'review';
      this.showRemoveModal = true;
    },
    constructPayload(model): any {
      const basePayload = {};
      if (model.action === 'add') {
        set(basePayload, 'memberAccountId', toString(this.accountId));
      }
      if (model.action) {
        delete model.action;
      }
      return Object.assign(basePayload, {
        ssn: InputMaskTypes.ssn.formatForAPI(model.ssn),
        firstName: model.firstName.toUpperCase(),
        lastName: model.lastName.toUpperCase(),
        sharePercentage: toString(model.sharePercentage),
        relationship: model.relationship,
        startDate: model.startDate ? model.startDate : moment().format(datePickerFormat),
        type: model.type,
      });
    },
    constructUpdateActions(): Array<Promise<any>> {
      return this.pendingBeneficiaries.reduce((actionArray, obj) => {
        if (!isNil(obj.id) && obj.action === 'update') {
          actionArray.push(
            this.$store.dispatch(
              'updateBeneficiaryInformation',
              {
                id: obj.id,
                payload: this.constructPayload(obj),
              },
            ),
          );
        }
        return actionArray;
      }, []);
    },
    constructAddActions(): Array<Promise<any>> {
      return this.pendingBeneficiaries.reduce((actionArray, obj) => {
        if (obj.action === 'add') {
          actionArray.push(
            this.$store.dispatch('addBeneficiary',
            {
              payload: this.constructPayload(obj),
            }),
          );
        }
        return actionArray;
      }, []);
    },
    submitBeneficiaries(): void {
      this.isSubmitLoading = true;
      // First update and remove beneficiaries
      Promise.all(this.constructUpdateActions())
        .then(() => {
          // If that works, add the new ones
          Promise.all(this.constructAddActions())
            .then(() => {
              this.refreshBeneficiaries();
            })
            .catch(() => {
              this.changeMade = false;
              this.showSubmitErrorMessage = true;
              this.isSubmitLoading = false;
            });
        })
        .catch(() => {
          this.changeMade = false;
          this.showSubmitErrorMessage = true;
          this.isSubmitLoading = false;
        });
    },
    refreshBeneficiaries(): void {
      this.$store
        .dispatch('getBeneficiaryInformation', this.accountId)
        .then(() => {
          this.changeMade = false;
          this.showSubmitSuccessMessage = true;
          this.isSubmitLoading = false;
        })
        .catch(() => {
          this.changeMade = false;
          this.showSubmitErrorMessage = true;
          this.isSubmitLoading = false;
        });
    },
    backToReviewScreen(hasChanges): void {
      if (hasChanges) {
        this.showConfirmModal = true;
      } else {
        this.showConfirmModal = false;
        this.currentBeneficiary = null;
        this.showReviewScreen = true;
      }
    },
    closeScreen(hasChanges): void {
      this.changeMade = hasChanges;
      this.closeFullscreenWrapper();
    },
  },
  components: {
    BeneficiaryForm,
    BeneficiariesReview,
    FullscreenWrapper,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
